import React from "react";
import styles from "./GameCityRewardsBanner.module.scss";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import botLeft1 from 'images/Game City Rewards/Christmas/_0010_Christmas-Gift.png';
import botLeft2 from 'images/Game City Rewards/Christmas/_0012_Christmas-Reindeer.png';
import botLeft3 from 'images/Game City Rewards/Christmas/_0013_Christmas-Snowman.png';
import botRight1 from 'images/Game City Rewards/Christmas/_0014_Christmas-Bear.png';
import botRight2 from 'images/Game City Rewards/Christmas/_0015_Christmas-Gingerbread.png';
import botRight3 from 'images/Game City Rewards/Christmas/_0016_Christmas-Santa.png';

import PricingFunctions from "common/PricingFunctions";
import { promoConfig } from "services/promoConfig";

const GameCityRewardsBanner = ({ showTopRibbon = true, showBottomRibbon = false, showShopButton = true, color, shrinkAvatars = false }) => {
    const pricing = useSelector(state => state.pricing);
    let countryCode = pricing.countryCode;
    const navigate = useNavigate();

    // Get regional pricing thresholds
    const localeLower = PricingFunctions.getRewardsLower(countryCode);
    const localeMid = PricingFunctions.getRewardsMid(countryCode);
    const currencySymbol = PricingFunctions.getCurrencySymbol(countryCode);

    // Campaign-driven content (falls back to defaults; subtitle derives from the active discount).
    const cfg = promoConfig.getConfig();
    const ribbonPhrase = cfg.bannerRibbonText || "PERFECT PARTY NIGHT";
    const bannerTitle = cfg.bannerTitle || "Buy TV Party Games — Play Tonight on Your Big Screen";
    const bannerSubtitle = cfg.bannerSubtitle
        || `Buy ${cfg.minGames ?? 3} or more games get ${cfg.discountPercent ?? 30}% off!`;

    const ribbonText = Array(10).fill(ribbonPhrase).map((text, index) => (
        <span key={index} className={styles.ribbonText}>
            {text} <span className={styles.dot}>•</span>
        </span>
    ));

    const isMobileWidth = () => {
        return window.innerWidth < 500;
    }

    return (
        <div className={`${styles.gameCityRewardsBanner} ${!showShopButton ? styles.noButton : ''}`} style={color ? { backgroundColor: color } : undefined}>

            {/*<img className={`${styles.bot} ${styles.left} ${styles.three} ${shrinkAvatars && styles.small}`} src={botLeft3} alt="bot-left" />*/}
            {/*<img className={`${styles.bot} ${styles.left} ${styles.two} ${shrinkAvatars && styles.small}`} src={botLeft2} alt="bot-left" />*/}
            {/*<img className={`${styles.bot} ${styles.left} ${styles.one} ${shrinkAvatars && styles.small}`} src={botLeft1} alt="bot-left" />*/}

            {/*<img className={`${styles.bot} ${styles.right} ${styles.three} ${shrinkAvatars && styles.small}`} src={botRight3} alt="bot-right" />*/}
            {/*<img className={`${styles.bot} ${styles.right} ${styles.two} ${shrinkAvatars && styles.small}`} src={botRight2} alt="bot-right" />*/}
            {/*<img className={`${styles.bot} ${styles.right} ${styles.one} ${shrinkAvatars && styles.small}`} src={botRight1} alt="bot-right" />*/}

            {showTopRibbon && !isMobileWidth() &&
                <div className={styles.ribbon}>
                    <div className={styles.ribbonContent}> {ribbonText}{ribbonText} </div>
                </div>
            }
            <h2 className={styles.title}>{bannerTitle}</h2>
            <p className={styles.description}>{bannerSubtitle}</p>
            {showShopButton && <button onClick={() => navigate("/shop")} className={`${styles.button} ${styles.alternate} ${styles.wide}`}>SHOP NOW</button>}
            {showBottomRibbon &&
                <div className={`${styles.ribbon} ${styles.bottom}`}>
                    <div className={styles.ribbonContent}> {ribbonText}{ribbonText} </div>
                </div>
            }
        </div>
    );
};

export default GameCityRewardsBanner;